module.exports = __webpack_public_path__ + "static/media/green.78a0c2aa.jpg";